import React, { ReactNode } from 'react';
import { Payment } from '../../../../../../../store/users';
import AndroidPlatform from './Android';
import IOSPlatform from './iOS';

interface IKeyValueRowProps {
  label: string;
  value?: ReactNode;
  className?: string;
}

export function KeyValueRow({ label, value, className }: IKeyValueRowProps) {
  return (
    <div className={`kv-row ${className}`}>
      <div className="kv-key">
        {label}
      </div>
      <div className="kv-val">{value ? `${value}` : '-'}</div>
    </div>
  );
}

KeyValueRow.defaultProps = {
  value: undefined,
  className: '',
};

export interface IPaymentProps {
  data: Payment
}

function PaymentDetails({ data }: IPaymentProps) {
  return data.platform === 'android'
    ? <AndroidPlatform data={data} />
    : <IOSPlatform data={data} />;
}

export default PaymentDetails;
